import { React, useState, useEffect } from 'react'
import styles from './MiddleChartPanel.module.scss'
import { useGeoState,useGeoFetch } from '../../../components/GeoProvider'
import ErrorMessage from '../../../components/Layout/ErrorMessage'
import HorizontalColumnBarChart from '../../../components/HorizontalColumnBarChart'
import PieChart from '../../../components/PieChart'
import AreaChart from '../Charts/AreaChart'
import ErrorLogs from '../../../components/ErrorBoundary/errorlogs'
import { useAuthState } from '../../../components/AuthProvider'
import Spinner from '../../../components/Loader/Spinner'
import {startDate} from '../dates'
const MiddleCharts = ({ geo_type, geo_id }) => {    
  const { user } = useAuthState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getManufacData, setManufacData] = useState()
  const [getProviderData, setProviderData] = useState()
  const [getProviderTrendData, setProviderTrenedData] = useState()
  const [isManfLoading,setIsManfLoading] =useState(false)
  const [isTrendLoading,setIsTrendLoading] =useState(false)
  const [isPieLoading,setIsPieLoading] =useState(false)
  const {
    locationName,
    displayDate,
    diseaseSelected,
  } = useGeoState()
  const { data: statesData, error: MapError } = useGeoFetch(
    displayDate,
    displayDate,
    'allergiesmanufacturer',
    `${geo_type}/${diseaseSelected}/?geo_id=${geo_id}`
  )

  useEffect(() => {
    setIsManfLoading(true)
    if (statesData !== null && statesData !== undefined) {
      if (statesData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setManufacData(statesData.response_data)
        seterrorOccured(false)
      } else {
        setManufacData(null)
        setErrorCode(statesData.response_code)
        setErrorMessage(statesData.response_message)
        setErrorSubject(statesData.response_subject)
        seterrorOccured(true)
      }
      setIsManfLoading(false)
    }
  }, [statesData])

  const { data: providerData, error: providerError } = useGeoFetch(
    displayDate,
    displayDate,
    'allergiesprovidertype',
    `${geo_type}/${diseaseSelected}/?geo_id=${geo_id}`
  )

  useEffect(() => {
    setIsPieLoading(true)
    if (providerData !== null && providerData !== undefined) {
      if (providerData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setProviderData(providerData.response_data)
        seterrorOccured(false)
      } else {
        setErrorCode(providerData.response_code)
        setErrorMessage(providerData.response_message)
        setErrorSubject(providerData.response_subject)
        seterrorOccured(true)
        setProviderData(null)
      }
      setIsPieLoading(false)
    }
  }, [providerData])

  const { data: providerTrendData, error: providerTrendError } = useGeoFetch(
    startDate,
    displayDate,
    'allergiesprovidertrend',
    `${geo_type}/${diseaseSelected}/?geo_id=${geo_id}`
  )

  useEffect(() => {
    setIsTrendLoading(true)
    if (providerTrendData !== null && providerTrendData !== undefined) {
      if (providerTrendData.response_code === 200) {
        ErrorLogs({
          message_type: 'Activity',
          error_details: 'Dashboard access success',
          user: user,
        })
        setProviderTrenedData(providerTrendData.response_data)
        seterrorOccured(false)
      } else {
        setErrorCode(providerTrendData.response_code)
        setErrorMessage(providerTrendData.response_message)
        setErrorSubject(providerTrendData.response_subject)
        seterrorOccured(true)
        setProviderTrenedData(null)
      }
      setIsTrendLoading(false)
    }
  }, [providerTrendData])



  return  (
    <>
    <div className={styles.base}>
      <div className={styles.pharPanel}>
      <div className={styles.header}>
          <span className={styles.captionFormat}>
            Pharma Manufacturers
          </span>
      </div>
      <div className={styles.componentDivBar}>
      {
        getManufacData!==undefined&&!isManfLoading?
        <HorizontalColumnBarChart data={getManufacData} 
        chartName="columnBarChartAllergies" 
        locationName={locationName} 
        height={500}
        chart_data_type={'allergic'}
      />  :<Spinner/>
      }
      </div>
      </div>
      <div className={styles.proPanel}>
      <div className={styles.header} >
     
          <span className={styles.captionFormat}>
          Provider Trends
           
          </span>
       
      </div>
      <div className={styles.componentDivArea}>
      {getProviderTrendData!==undefined&&!isTrendLoading? 
        <AreaChart data={getProviderTrendData}  
        geo_id={geo_id} 
        locationName={locationName}  />  :
        <Spinner/>
      }
     
      </div>
      </div>
  
   
      <div className={styles.presPanel}>
      <div className={styles.header}>
              <span className={styles.captionFormat}>
              NDC Counts by Provider Type
          </span>
      </div>
      <div className={styles.componentDiv}>
        {
          getProviderData!==undefined&&!isPieLoading?
          <PieChart
            chartName={'providerTypeChart'}
            chartData={getProviderData}
            locationName={locationName} 
          /> :<Spinner/> 
        }
      </div>
      </div>
    </div>
    </>
  ) 
}

export default MiddleCharts
